import { render } from "./SavedReports.vue?vue&type=template&id=59fdc452"
import script from "./SavedReports.vue?vue&type=script&lang=js"
export * from "./SavedReports.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__